export default class AppUtils {
  public static getErrorText(error: any): string {
    let msg: string = 'Unknown error'
    if (!!error) {
      msg = `${error.status} ${error.statusText} :: `
      if (!!error.error) {
        if (!!error.error.Message) {
          msg += `${error.error.Message}`
        } else if (!!error.error.message) {
          msg += `${error.error.message}`
        } else if (!!error.message) {
          msg += `${error.message}`
        }
      }
    }
    return msg
  }
}
